import React, { Component } from 'react';
import _ from 'lodash';

import styles from './InsightCard.scss';

const defaultStyle = {
  lowWidth: 30,
  normalWidth: 40,
  highWidth: 30
};

class AnalysisItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lowWidth: 30,
      normalWidth: 40,
      highWidth: 30,
      lowLabel: '',
      highLabel: '',
      currentLabel: '',
      valueType: '',
      isLoaded: false,
      labelStyle: {}
    }

    this.chartContainerRef = React.createRef();
    this.currentLabelRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      isLoaded: false
    });

    if (this.props) {
      this.calculateChartZones();
    }

    if (window.ResizeObserver && this.chartContainerRef.current) {
      this.chartSizeObserver = new window.ResizeObserver(() => this.setState({ labelStyle: null }));
      this.chartSizeObserver.observe(this.chartContainerRef.current);
    }
  }

  componentWillUnmount() {
    if (this.chartSizeObserver) this.chartSizeObserver.disconnect();
  }

  componentDidUpdate(prevProps) {
    if (this.props.values && prevProps.values != this.props.values) {
      this.setState({
        isLoaded: false
      });
      this.calculateChartZones();
    }
    if (this.state.labelStyle === null) {
      this.setState({ labelStyle: this.labelPosition() });
    }
  }

  calculateChartZones() {
    if (this.props.values) {
      const { high, currentValue } = this.props.values;
      let low = this.props.values.low;

      let currentValueLabelPercentage = 0;

      if (_.isNumber(low) && _.isNumber(high) && _.isNumber(currentValue)) {
        let lowLabel = `${low.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;
        let highLabel = `${high.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;
        let currentLabel = `${currentValue.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;

        let valueType = !this.props.valueType || this.props.valueType === '%'
          ? ''
          : this.props.valueType;

        if (this.props.valueType === '%') {
          lowLabel = `${lowLabel}%`;
          highLabel = `${highLabel}%`;
          currentLabel = `${currentLabel}%`;
        }

        let { lowWidth,
          highWidth,
          normalWidth } = defaultStyle;

        if (low === high && currentValue !== low) {
          lowWidth = 50;
          highWidth = 50;
          normalWidth = 0;
          highLabel = undefined;
        } else if (low == 0 || low === high) {
          lowWidth = 0;
          normalWidth = 50;
          highWidth = 50;
          lowLabel = undefined;
          low = 0;
        }

        if (currentValue == low) {
          currentValueLabelPercentage = lowWidth;
          lowLabel = undefined;
        }

        if (currentValue == high) {
          currentValueLabelPercentage = lowWidth + normalWidth;
        } else if (currentValue < low) {
          currentValueLabelPercentage = currentValue === 0 ? 0 : this.leftAlignment(low, currentValue, 0, lowWidth);
        } else if (currentValue > low && currentValue < high) {
          currentValueLabelPercentage = this.leftAlignment(high, currentValue, low, normalWidth) + lowWidth;
        } else if (currentValue > high) {
          currentValueLabelPercentage = lowWidth + normalWidth + this.leftAlignment(high + low, currentValue, high, highWidth);
        }

        this.setState(
          {
            lowLabel,
            highLabel,
            currentLabel,
            lowWidth,
            normalWidth,
            highWidth,
            currentValuePercentage: currentValueLabelPercentage,
            valueType,
            isLoaded: true,
            labelStyle: null
          });
      }
    }
  }

  leftAlignment(max, middle, min, width) {
    const rightDiff = max - middle;
    const leftDiff = middle - min;

    if (rightDiff < leftDiff) {
      return (width / 3) * 2;
    } else if (rightDiff == leftDiff) {
      return width / 2;
    } else { //higher - lower > lower
      return width / 3;
    }
  }

  labelPosition() {

    if (this.currentLabelRef && this.chartContainerRef && _.isNumber(this.state.currentValuePercentage)) {

      const labelElementWidth = this.currentLabelRef.current.getBoundingClientRect().width;
      const chartElementWidth = this.chartContainerRef.current.getBoundingClientRect().width;
      const sideChartMargin = 0;

      const leftOverflowInPx = labelElementWidth / 2 - (((this.state.currentValuePercentage * chartElementWidth) / 100) + sideChartMargin);

      const rightOverflowInPx = labelElementWidth / 2 - ((((100 - this.state.currentValuePercentage) * chartElementWidth) / 100) + sideChartMargin);

      if (leftOverflowInPx > 0) {
        return { transform: `translateX(${leftOverflowInPx}px)` };
      }

      if (rightOverflowInPx > 0) {
        return { transform: `translateX(${-1 * rightOverflowInPx}px)` }
      }
    }
    return {};
  }
  render() {
    const { lowLabel, highLabel, currentLabel, valueType, lowWidth, normalWidth, highWidth } = this.state;
    const unit = () => (valueType ? ` ${valueType}` : '');
    const threshold = (name, value) => (
      <div className='threshold' title={value}>
        <span className='threshold-name'>{name}</span>
        <span className='threshold-value'>{value}{unit(value)}</span>
      </div>
    );
    return (
      <div className='analysis-process analysis-process--marker' ref={this.chartContainerRef} style={{ visibility: this.state.isLoaded ? 'visible' : 'hidden'}}>
        {lowWidth > 0 &&
          <div className='analysis-process-item low' style={{width: lowWidth + "%"}}>
            <div className='bg'></div>
            {lowLabel && threshold('Low', lowLabel)}
          </div>
        }
        <div className='analysis-process-item normal' style={{ width: normalWidth + "%" }}>
          <div className='bg'></div>
          {/* the middle zone keeps its original name, over the zone, when it is wide enough not to meet Low and High */}
          {normalWidth >= 20 && <span className='zone-name'>Stable</span>}
          {highLabel && threshold('High', highLabel)}
        </div>
        <div className='analysis-process-item high' style={{ width: highWidth + "%" }}>
          <div className='bg'></div>
        </div>

        <div className={'analysis-process-item current'} style={{ left: this.state.currentValuePercentage + "%" }}>
          <span className='marker'></span>
          <div className='value' title={currentLabel}>
            <span style={this.state.labelStyle} ref={this.currentLabelRef}>
              <span className='value-name'>Your {this.props.labelText}</span>
              <span className='value-number'>{currentLabel}{unit(currentLabel)}</span>
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default AnalysisItem;
